
import React, { useState, useMemo } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
  TableRow, Table,
  TableHead,TableContainer,
  Paper,
  TableBody,
  TableCell,
  Checkbox, FormControlLabel, FormHelperText, Divider,
  CircularProgress,
  Typography,
  Chip,
  InputAdornment,
  Menu,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Card, Box } from "@material-ui/core";
import EventService from "./Locality/Service/eventService";
import AddClassService from "./Locality/Service/addClassService";
import StudentService from "./Locality/Service/studentService";
import SectionService from "./Locality/Service/sectionService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility'
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AddIcon from '@material-ui/icons/Add';
import EventIcon from '@material-ui/icons/Event';
import GroupIcon from '@material-ui/icons/Group';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { makeStyles } from '@material-ui/core/styles';


const getFormSelectedStudents = (studentList, studentIds, isEventForAllStudent, isEditing) => {
  const list = Array.isArray(studentList) ? studentList : [];
  const ids = new Set((Array.isArray(studentIds) ? studentIds : []).map(String));

  if (isEventForAllStudent) {
    if (!isEditing && ids.size === 0) return list;
    return list.filter((student) => ids.has(String(student._id)));
  }

  return list.filter((student) => ids.has(String(student._id)));
};

const getCreatedByLabel = (createdBy) => {
  if (!createdBy) return '—';
  if (createdBy.teacher?.teacherName) return createdBy.teacher.teacherName;
  if (createdBy.school?.schooleName) return createdBy.school.schooleName;
  if (Array.isArray(createdBy.students) && createdBy.students.length > 0) {
    const names = createdBy.students.map((s) => s?.firstName).filter(Boolean);
    if (names.length) return names.join(', ');
  }
  return createdBy.userName || createdBy.serialNumber || '—';
};

const extractEventStudentIds = (row) => {
  if (!row) return [];
  const ids = new Set();

  if (Array.isArray(row.eventStudentDetailsListId)) {
    row.eventStudentDetailsListId.forEach((detail) => {
      const studentId = detail?.studentId?._id || detail?.studentId;
      if (studentId) ids.add(String(studentId));
    });
  }

  if (Array.isArray(row.studentId)) {
    row.studentId.forEach((student) => {
      const studentId = student?._id || student;
      if (studentId) ids.add(String(studentId));
    });
  } else if (row.studentId) {
    const studentId = row.studentId?._id || row.studentId;
    if (studentId) ids.add(String(studentId));
  }

  return Array.from(ids);
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  formControl: {},
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#0f2d4d',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#6b7280',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  primaryBtn: {
    backgroundColor: '#1769d6',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '8px 18px',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#eef4ff',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1769d6',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  filtersCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filtersRow: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    width: '100%',
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    height: 40,
    boxSizing: 'border-box',
    padding: '0 12px',
    borderRadius: 8,
    border: '1px solid #d9dee7',
    backgroundColor: '#f7f9fc',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#0f2d4d',
    userSelect: 'none',
    flexShrink: 0,
  },
  countBadge: {
    backgroundColor: '#fff',
    color: '#1769d6',
    border: '1px solid #cfe0fb',
    borderRadius: 12,
    padding: '1px 10px',
    fontSize: '0.72rem',
    fontWeight: 700,
    marginLeft: 8,
  },
  fieldLabel: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#46566b',
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minHeight: 18,
    lineHeight: '18px',
  },
  resetBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
    border: '1px solid #d9dee7',
    height: 40,
    minWidth: 88,
    padding: '0 16px',
  },
  filterFieldWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    minWidth: 150,
  },
  filterActionsWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
    justifyContent: 'flex-end',
  },
  tableCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
  },
  iconBtnOutlined: {
    border: '1px solid #d9dee7',
    borderRadius: 8,
    padding: 8,
    color: '#46566b',
  },
  classChip: {
    backgroundColor: '#e8f0fe',
    color: '#1769d6',
    fontWeight: 600,
    borderRadius: 6,
  },
  sectionChip: {
    backgroundColor: '#eef4ff',
    color: '#46566b',
    fontWeight: 600,
    borderRadius: 6,
  },
  submittedChip: {
    backgroundColor: '#e6f7ed',
    color: '#1a9b54',
    fontWeight: 600,
    borderRadius: 6,
  },
  notSubmittedChip: {
    backgroundColor: '#ffebee',
    color: '#c62828',
    fontWeight: 600,
    borderRadius: 6,
  },
  resubmitChip: {
    backgroundColor: '#fff4e5',
    color: '#c77700',
    fontWeight: 600,
    borderRadius: 6,
  },
  countPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    backgroundColor: '#eef4ff',
    color: '#1769d6',
    borderRadius: 14,
    padding: '2px 10px',
    fontWeight: 600,
    fontSize: '0.8rem',
  },
  docPill: {
    backgroundColor: '#e6f7ed',
    color: '#1a9b54',
    borderRadius: 12,
    padding: '1px 8px',
    fontWeight: 600,
    fontSize: '0.72rem',
    marginLeft: 6,
  },
  dialogPaper: {
    borderRadius: 14,
    width: 560,
    maxWidth: '95vw',
  },
  dialogTitleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2.5),
    borderBottom: '1px solid #eef1f5',
  },
  dialogTitleText: {
    fontWeight: 700,
    fontSize: '1.15rem',
    color: '#0f2d4d',
  },
  dialogBody: {
    padding: theme.spacing(2.5),
  },
  sectionLabel: {
    fontWeight: 700,
    color: '#46566b',
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(1.25),
  },
  formSection: {
    marginBottom: theme.spacing(2.5),
  },
  uploadBox: {
    border: '1px dashed #c5d3e6',
    borderRadius: 10,
    backgroundColor: '#f8fafc',
    padding: theme.spacing(2),
  },
  uploadBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: '#0f2d4d',
    color: '#fff',
    '&:hover': { backgroundColor: '#0a2038' },
  },
  dialogFooter: {
    padding: theme.spacing(1.5, 2.5),
    borderTop: '1px solid #eef1f5',
  },
  cancelBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
  },
  addBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: '#1769d6',
    color: '#fff',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
  },
}));
export default function Event() {
  const tableHeaders = ['Number of students', 'Assignment Name ',  'Assignment  Date', 'Last  Date for submission', 'Remarks', 'Edit', 'Delete'];
  const [images, setImages] = useState('');
  const [imageslist, setImagesList] = useState([]);
  const [message, setMessage] = useState("");
  const classes = useStyles();
  const [studentList, setStudentList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [listSectionList, setListSectionList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [dueDate, setFormDueDate] = useState("");
  const [age, setAge] = React.useState('');
  var [error, setError] = useState(null);
  var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(100);
  const current = new Date();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectEventName, setEventName] = useState({});
  const [remarkDrafts, setRemarkDrafts] = useState({});
  const [remarkSavingId, setRemarkSavingId] = useState(null);
  const [editingRemarkId, setEditingRemarkId] = useState(null);
const [openDialog, setOpenDialog] = useState(false);
  var [classId, setClassId] = useState("");
  const [listClassId, setListClassId] = useState("");
  const [listSectionId, setListSectionId] = useState("");
  const [addEventLoading, setAddEventLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
  const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
  var [dateValue, setDateValue] = useState(date);
  const [eventId, setEventId] = useState('');
  // ---- Redesigned UI state ----
  const [noteOpen, setNoteOpen] = useState(true);
  const [remarksDialog, setRemarksDialog] = useState({ open: false, title: '', content: '' });
  const [deleteConfirm, setDeleteConfirm] = useState({ open: false, row: null });
  const [deleteLoading, setDeleteLoading] = useState(false);

  const openRemarksDialog = (event) => {
    setRemarksDialog({
      open: true,
      title: event?.assignmentName || event?.eventName || 'Remarks',
      content: event?.discription || '',
    });
  };

  const closeRemarksDialog = () =>
    setRemarksDialog({ open: false, title: '', content: '' });

  const openDeleteConfirm = (row) =>
    setDeleteConfirm({ open: true, row: row || null });

  const closeDeleteConfirm = () => {
    if (deleteLoading) return;
    setDeleteConfirm({ open: false, row: null });
  };
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
  const [actionMenu, setActionMenu] = useState({ anchorEl: null, row: null });
  const [visibleCols, setVisibleCols] = useState({
    students: true,
    createdBy: true,
    section: true,
    eventDate: true,
    dueDate: true,
    remarks: true,
  });
  const columnConfig = [
    { id: 'students', label: 'Students' },
    { id: 'createdBy', label: 'Created By' },
    { id: 'section', label: 'Section' },
    { id: 'eventDate', label: 'Event Date' },
    { id: 'dueDate', label: 'Last Date for Submission' },
    { id: 'remarks', label: 'Remarks' },
  ];
  const openActionMenu = (e, row) => setActionMenu({ anchorEl: e.currentTarget, row });
  const closeActionMenu = () => setActionMenu({ anchorEl: null, row: null });
  const [year, month, day] = date.split("-");
  const [event, setEvent] = useState({
    eventName: '',
    imageURL: '',
    discription: '',
    classId: '',
    sectionId: '',
    date: '',
    dueDate: '',
    status: 'Not Submitted',
    studentId: [],
    isEventForAllStudent: false,
    isEdit: false
  });

  const validationSchema = Yup.object().shape({
    eventName: Yup.string().required('event Name is required'),
        studentId: Yup.array(),
    dueDate: Yup.string(),
    date: Yup.string(),
    status: Yup.string(),
    classId: Yup.string().required('Class Name is required'),
    discription: Yup.string(),

    isEdit:Yup.boolean(),
  });
  const handleOpen = (status) => {


    if (status) {
      const initialClassId =
        (userDetails.role === 'TEACHER' && userDetails.classId)
          ? userDetails.classId
          : (listClassId || '');
      const initialSectionId =
        (userDetails.role === 'TEACHER' && userDetails.sectionId)
          ? userDetails.sectionId
          : (listSectionId || '');
      setEvent({
        eventName: '',
        imageURL: '',
        discription: '',
        classId: initialClassId,
        sectionId: initialSectionId,
        date: '',
        dueDate: '',
        status: 'Not Submitted',
        studentId: [],
        isEventForAllStudent: false,
      })
      setImagesList([]);
      if (initialClassId) {
        getSectionListByClass(initialClassId);
        getStudentList({ target: { value: initialClassId } }, null, initialSectionId || undefined);
      } else {
        setSectionList([]);
        setStudentList([]);
      }
    }

    setOpen(true);
  };
  const handleChangePage = (event, newpage) => {
    setpg(newpage);
  }
  const handleChangeRowsPerPage = (event) => {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }
  useEffect(() => {
    getEventList();

    getAddClassList();
    return () => {
      setEventList([]);
      setStudentList([]);
    }
  }, []);
  const dateAndTime = (date) => {

    const systemDate = new Date(date);
    const formattedDateTime = systemDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true,

    });
    return formattedDateTime;
  }
  
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormDueDate(value);
  };
  const handleFileChange = (e) => {
    setImages(e.target.files); // Store all selected files in state
  };
  const handleUpload = async (e) => {
    e.preventDefault();

    const fileArray = images ? Array.from(images) : [];
    if (fileArray.length === 0) {
      setMessage("Please select images first.");
      return;
    }

    try {
      // Backend accepts one file per request, so upload each selected file in parallel.
      const uploadResults = await Promise.all(
        fileArray.map((image) => {
          const formData = new FormData();
          formData.append(`image`, image);
          formData.append(`imageName`, image.name);
          return EventService.uploadImage(formData);
        })
      );

      const urls = uploadResults.map((res) => res?.url).filter(Boolean);
      setImagesList((prev) => [...prev, ...urls]);
      setImages([]);
      alert(` uploaded successfully`);
    } catch (error) {
      console.error("Error uploading images:", error);
      setMessage("An error occurred while uploading the images.");
      alert(error?.message || "An error occurred while uploading the images.");
    }
  };
  // const getEventList = () => {
  //   EventService.getAllEvent().then((res) => {

  //     setEventList(res);
  //   }).catch((err) => {
  //     setError(err.message);
  //   });
  // }
  function getSectionListByClass(classId) {
    if (!classId) {
      setSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    }).then((res) => {
      let list = Array.isArray(res) ? res : [];
      // if (userDetails.role === "TEACHER" && userDetails.sectionId) {
      //   list = list.filter((s) => String(s._id) === String(userDetails.sectionId));
      // }
      setSectionList(list);
    }).catch(() => setSectionList([]));
  }

  function getListSectionListByClass(classId) {
    if (!classId) {
      setListSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    }).then((res) => {
      let list = Array.isArray(res) ? res : [];
      setListSectionList(list);
      if (list.length === 0) setListSectionId("");
    }).catch(() => {
      setListSectionList([]);
      setListSectionId("");
    });
  }

  const getEventList = (override = {}) => {
    const params = { schooleId: userDetails.schooleId };
    const classId = override.classId !== undefined ? override.classId : listClassId;
    const sectionId = override.sectionId !== undefined ? override.sectionId : listSectionId;
    if (classId) params.classId = classId;
    if (sectionId) params.sectionId = sectionId;
    EventService.getAllEvent(params)
      .then((res) => setEventList(res))
      .catch((err) => setError(err.message));
  };

  const onListClassChange = (e) => {
    const id = e.target.value;
    setListClassId(id);
    setListSectionId("");
    getListSectionListByClass(id);
    getEventList({ classId: id, sectionId: "" });
  };

  const onListSectionChange = (e) => {
    const id = e.target.value;
    setListSectionId(id);
    getEventList({ sectionId: id });
  };

  /** True when today is after the assignment due date (end of that day). */
  const isDueDatePassed = (dueDateValue) => {
    const normalized = toDateInputValue(dueDateValue);
    if (!normalized) return false;
    const [y, m, d] = normalized.split("-");
    const due = new Date(Number(y), Number(m) - 1, Number(d), 23, 59, 59, 999);
    if (Number.isNaN(due.getTime())) return false;
    return new Date() > due;
  };

  /** Normalize stored date to YYYY-MM-DD for <input type="date" />. */
  const toDateInputValue = (value) => {
    if (!value) return "";
    const s = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    const slash = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (slash) {
      const [, d, m, y] = slash;
      return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    }
    const parsed = new Date(s);
    if (!Number.isNaN(parsed.getTime())) return parsed.toISOString().slice(0, 10);
    return "";
  };

  // Function to format date to D/M/Y format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        // If dateString is already in YYYY-MM-DD format, parse it manually
        const parts = dateString.split("-");
        if (parts.length === 3) {
          const day = parts[2];
          const month = parts[1];
          const year = parts[0];
          return `${day}/${month}/${year}`;
        }
        return dateString;
      }
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const handleOpen1 = () => {
    setOpen1(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const getAddClassList = (event) => {
    AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
      // if (userDetails.role === "TEACHER") {
      //   res = res.filter(r => r._id === userDetails.classId);
      // }
      setAddClassList(res);
      if (userDetails.classId) {
        setClassId(userDetails.classId);
        setListClassId(userDetails.classId);
        if (userDetails.sectionId) setListSectionId(userDetails.sectionId);
        getSectionListByClass(userDetails.classId);
        getListSectionListByClass(userDetails.classId);
        getEventList({ classId: userDetails.classId, sectionId: userDetails.sectionId || "" });
        getStudentList({ target: { value: userDetails.classId } }, null, userDetails.sectionId);
      } else {
        setClassId("");
        setListClassId("");
        setListSectionId("");
      }
    }).catch((err) => {
      // setError(err.message);
    });
  }
  const viewMore = (event) => {
    const students = event.eventStudentDetailsListId || [];
    setSelectedStudents(students);
    const drafts = {};
    students.forEach((student) => {
      if (student._id) drafts[student._id] = student.remark || '';
    });
    setRemarkDrafts(drafts);
    setEditingRemarkId(null);
    setEventName(event);
    setOpenDialog(true);
  };
  const editEvent = (row, status) => {
    const obj = JSON.parse(JSON.stringify(row));
    obj.classId = row.classId ? row.classId._id : "";
    obj.sectionId = row.sectionId ? row.sectionId._id || row.sectionId : "";
    obj.studentId = extractEventStudentIds(row);
    obj.date = toDateInputValue(row.date);
    obj.dueDate = toDateInputValue(row.dueDate);
    obj.isEventForAllStudent = Boolean(row.isEventForAllStudent);
    setImagesList(Array.isArray(row.imageURL) ? row.imageURL : []);
    getAddClassList();
    if (obj.classId) {
      getSectionListByClass(obj.classId);
      getStudentList({ target: { value: obj.classId } }, null, obj.sectionId || undefined);
    }
    if (status) {
      delete obj._id;
    }
    obj.isEdit = true;
    setEvent(obj);
    handleOpen();
  };

  const deleteEvent = (eventdelete) => {
    if (!eventdelete) return Promise.resolve();
    return EventService.deleteEvent(eventdelete).then(() => {
      getEventList();
    });
  };

  const confirmDeleteEvent = () => {
    const row = deleteConfirm.row;
    if (!row) return;
    setDeleteLoading(true);
    deleteEvent(row)
      .then(() => {
        setDeleteConfirm({ open: false, row: null });
      })
      .catch(() => {})
      .finally(() => {
        setDeleteLoading(false);
      });
  };


  function getStudentList(event, obj, sectionId) {
    const classId = event?.target?.value;
    const getSpeList = { classId };
    if (sectionId) getSpeList.sectionId = sectionId;
    StudentService.getAllStudentById(userDetails.schooleId, getSpeList).then((res) => {
      const studentDetails = res.map(r => ({
        _id: r._id,
        studentName: `${r.firstName} ${r.lastName}`,
        status: true
      }));
      setStudentList(studentDetails);
    }).catch((err) => {
      // setError(err.message);
    });
  }

  const formik = useFormik({
    initialValues: event,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      const isEditing = Boolean(values._id || event._id);

      if (!values.isEventForAllStudent && (!values.studentId || values.studentId.length === 0)) {
        alert('Please select at least one student.');
        return;
      }

      if (values.isEventForAllStudent) {
        if (!values.classId) {
          alert('Please select a class first.');
          return;
        }
        if (isEditing && (!values.studentId || values.studentId.length === 0)) {
          alert('Please select at least one student.');
          return;
        }
        if (!isEditing && studentList.length === 0) {
          const effectiveSectionId = values.sectionId || null;
          alert(
            effectiveSectionId
              ? 'No students found in the selected section or class. Please add students to this section or class or choose a different section or class.'
              : 'No students found in the selected class. Please add students to this class or choose a different class.'
          );
          return;
        }
      }

      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      values.schooleId = userDetails.schooleId;
      values.studentId = Array.isArray(values.studentId)
        ? values.studentId.map(String)
        : (values.studentId ? [String(values.studentId)] : []);
      values.sectionId = values.sectionId || null;
      setAddEventLoading(true);
      if (values._id || event._id) {
        values._id = values._id || event._id;
        values.imageURL = imageslist;
        EventService.upadeEvent(values).then((res) => {
          setAddEventLoading(false);
          handleClose();
          getEventList();
          resetForm()
          setImagesList([])
          alert(" Event Updated Successfully.");
        }).catch((err) => {
          setAddEventLoading(false);
          alert(err?.response?.data?.message || err?.message || "Error updating event");
        });
      }
      else {
        values.imageURL = imageslist;
        EventService.creteEvent(values).then((res) => {
          setAddEventLoading(false);
          getEventList();
          resetForm();
          handleClose();
          alert(" Event Added Successfully.");
          setImagesList([])
        })
          .catch((err) => {
            setAddEventLoading(false);
            alert(err?.response?.data?.message || err?.message || "Error adding event");
          })
      }

    },
  });

  const isFormEditing = Boolean(formik.values._id || event._id);

  const formSelectedStudents = useMemo(
    () =>
      getFormSelectedStudents(
        studentList,
        formik.values.studentId,
        formik.values.isEventForAllStudent,
        isFormEditing
      ),
    [
      studentList,
      formik.values.studentId,
      formik.values.isEventForAllStudent,
      isFormEditing,
    ]
  );

  const showFormStudentRows =
    formSelectedStudents.length > 0 &&
    (formSelectedStudents.length > 1 || formik.values.isEventForAllStudent);

  const removeFormStudent = (studentIdToRemove) => {
    const currentIds = (Array.isArray(formik.values.studentId)
      ? formik.values.studentId
      : []
    ).map(String);
    const removeId = String(studentIdToRemove);

    let nextIds;
    if (
      formik.values.isEventForAllStudent &&
      !isFormEditing &&
      currentIds.length === 0
    ) {
      nextIds = studentList
        .map(({ _id }) => String(_id))
        .filter((id) => id !== removeId);
      formik.setFieldValue('isEventForAllStudent', false);
    } else {
      nextIds = currentIds.filter((id) => id !== removeId);
      if (
        formik.values.isEventForAllStudent &&
        nextIds.length < studentList.length
      ) {
        formik.setFieldValue('isEventForAllStudent', false);
      }
    }
    formik.setFieldValue('studentId', nextIds);
  };

  const removeImage = (index, imageURL) => {
      EventService.deleteAzureImage({"imageURL":imageURL}).then((res) => {
        const updatedList = [...imageslist];
        updatedList.splice(index, 1);
        setImagesList(updatedList);
      }).catch((err) => {
      });
    

};
  const handleCheck = (event, item) => {
    // event.sounds.SPL
    event.sounds[item] = !event.sounds[item];
    // obj['a'] = true;

    StudentService.upadeStudent(event).then((res) => {
      getStudentList();

    })
      .catch((err) => {
        alert(err.response.data.message)
      })

  };
  const imageArtist = (eventdetails) => {
    getEventImageList(eventdetails.id);
    setEventId(eventdetails.id)

  }
  const getEventImageList = (eventId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    // CommonService.postRequest(IMAGES.GET+"/getlist", {artiesId:eventId}).then((res) => {
    //     setEventImageList(res);
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue, "eventId": userDetails.eventId
    }
    EventService.creteImages(keys).then((res) => {
      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

    });
  }

  const saveStudentRemark = (student) => {
    if (!student?._id) return;
    const remark = String(remarkDrafts[student._id] || '').trim();
    setRemarkSavingId(student._id);
    EventService.upadeStudentEvent({ _id: student._id, remark })
      .then(() => {
        setSelectedStudents((prev) =>
          prev.map((item) => (item._id === student._id ? { ...item, remark } : item))
        );
        setEditingRemarkId(null);
        alert('Remark saved successfully.');
      })
      .catch((err) => {
        alert(err?.response?.data?.message || err?.message || 'Failed to save remark');
      })
      .finally(() => setRemarkSavingId(null));
  };

  const startRemarkEdit = (student) => {
    if (!student?._id) return;
    setRemarkDrafts((prev) => ({
      ...(prev || {}),
      [student._id]: student.remark || prev?.[student._id] || '',
    }));
    setEditingRemarkId(student._id);
  };

  const cancelRemarkEdit = (student) => {
    if (!student?._id) return;
    setRemarkDrafts((prev) => ({
      ...(prev || {}),
      [student._id]: student.remark || '',
    }));
    setEditingRemarkId(null);
  };

  const submitAssigment = (values, status, options = {}) => {
    const { isResubmitRequest = false } = options;
    values.status = status;
    if (isResubmitRequest) {
      values.resubmit = "Resubmit";
    }

    EventService.upadeStudentEvent(values)
      .then(() => {
        const updated = selectedStudents.map((item) =>
          item._id === values?._id
            ? {
                ...item,
                status: isResubmitRequest ? item.status : status,
                resubmit: isResubmitRequest ? "Resubmit" : item.resubmit,
              }
            : item,
        );
        setSelectedStudents(updated);
        alert(isResubmitRequest ? "Resubmit request submitted." : "Submitted successfully.");
      })
      .catch((err) => {
        alert(err?.response?.data?.message || err?.message || "Update failed");
      });
  };

  const onSubmit = data => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue
    }
    EventService.creteEvent(keys).then((res) => {

      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

      alert(err.response.data.message);
    });
  };
  const filteredEvents = eventList.filter((ev) =>
    (ev.eventName || '').toLowerCase().includes(searchTerm.toLowerCase())
  );
  const activeFilterCount = [listClassId, listSectionId].filter(Boolean).length;
  const handleResetFilters = () => {
    setListClassId("");
    setListSectionId("");
    setListSectionList([]);
    setSearchTerm("");
    getEventList({ classId: "", sectionId: "" });
  };
  const headerCellStyle = {
    backgroundColor: '#f4f6fa',
    color: '#46566b',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #e6eaf0',
  };
  const visibleColCount = 3 + columnConfig.filter((c) => visibleCols[c.id]).length;

  return (

    <>
      {/* Page header */}
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Assignment</Typography>
          <Typography className={classes.pageSubtitle}>
            Create assignments and track student submissions.
          </Typography>
        </Box>
        <Button
          className={classes.primaryBtn}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleOpen(true)}
        >
          Add Assignment
        </Button>
      </Box>

      {/* Dismissible note */}
      {noteOpen && (
        <Box className={classes.noteBanner}>
          <span className={classes.noteIconWrap}>
            <InfoOutlinedIcon style={{ fontSize: 18 }} />
          </span>
          <Box flex={1}>
            <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#0f2d4d' }}>Note</Typography>
            <Typography variant="body2" style={{ color: '#46566b' }}>
              Use the actions menu to view submissions, edit, or delete an assignment. Click the student count to see who submitted.
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setNoteOpen(false)} aria-label="dismiss note">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

      {/* Filters card */}
      <Card className={classes.filtersCard} elevation={0}>
        <Box className={classes.filtersRow}>
          <Box
            className={classes.filtersChip}
            onClick={() => setFiltersOpen((o) => !o)}
            role="button"
            tabIndex={0}
          >
            <FilterListIcon fontSize="small" />
            <span>Filters</span>
            <span className={classes.countBadge}>{activeFilterCount}</span>
            {filtersOpen ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
          </Box>
          {filtersOpen && (
            <>
              <Box className={classes.filterFieldWrap}>
                <Typography className={classes.fieldLabel}>
                  <SchoolIcon style={{ fontSize: 16 }} /> Class
                </Typography>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select displayEmpty value={listClassId} onChange={onListClassChange}>
                    <MenuItem value=""><em>All Classes</em></MenuItem>
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box className={classes.filterFieldWrap}>
                <Typography className={classes.fieldLabel}>
                  <PersonIcon style={{ fontSize: 16 }} /> Section
                </Typography>
                <FormControl fullWidth variant="outlined" size="small" disabled={!listClassId || listSectionList.length === 0}>
                  <Select displayEmpty value={listSectionId} onChange={onListSectionChange}>
                    <MenuItem value=""><em>All Sections</em></MenuItem>
                    {listSectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box className={classes.filterActionsWrap}>
                <Typography className={classes.fieldLabel} style={{ visibility: 'hidden' }}>Reset</Typography>
                <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                  Reset
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Card>

      {/* Table card */}
      <Card className={classes.tableCard} elevation={0}>
        <Box className={classes.toolbar}>
          <Typography variant="body2" style={{ color: '#46566b', fontWeight: 600 }}>
            {filteredEvents.length} {filteredEvents.length === 1 ? 'Assignment' : 'Assignments'}
          </Typography>
          <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search by assignment name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ minWidth: 260 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" style={{ color: '#9aa6b6' }} />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="outlined"
              startIcon={<ViewColumnIcon />}
              onClick={(e) => setColumnMenuAnchor(e.currentTarget)}
              style={{ textTransform: 'none', color: '#46566b', borderColor: '#d9dee7' }}
            >
              Column
            </Button>
            <Tooltip title="Refresh">
              <IconButton className={classes.iconBtnOutlined} onClick={() => getEventList()}>
                <RefreshIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <TableContainer component={Paper} elevation={0} style={{ maxHeight: 540 }}>
          <Table stickyHeader className="mb-0 dashboard-table-row-hover">
            <TableHead>
              <TableRow>
                {visibleCols.students && <TableCell style={headerCellStyle}>Students</TableCell>}
                <TableCell style={headerCellStyle}>Assignment Name</TableCell>
                {visibleCols.createdBy && <TableCell style={headerCellStyle}>Created By</TableCell>}
                {/* <TableCell style={headerCellStyle}>Class</TableCell>
                {visibleCols.section && <TableCell style={headerCellStyle}>Section</TableCell>} */}
                {visibleCols.eventDate && <TableCell style={headerCellStyle}>Event Date</TableCell>}
                {visibleCols.dueDate && <TableCell style={headerCellStyle}>Last Date for Submission</TableCell>}
                {visibleCols.remarks && <TableCell style={headerCellStyle}>Remarks</TableCell>}
                <TableCell style={headerCellStyle} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEvents.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={visibleColCount} align="center" style={{ padding: 36, color: '#9aa6b6' }}>
                    No assignments found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredEvents.slice(pg * rpg, pg * rpg + rpg).map((event) => {
                  const studentCount = event.eventStudentDetailsListId?.length || 0;
                  const uploadedCount = event.eventStudentDetailsListId?.filter(
                    (s) => s.submissionFiles && s.submissionFiles.length > 0
                  ).length || 0;
                  const overdue = isDueDatePassed(event.dueDate);
                  return (
                    <TableRow key={event._id}>
                      {visibleCols.students && (
                        <TableCell>
                          <Tooltip title="View submissions">
                            <span
                              className={classes.countPill}
                              style={{ cursor: 'pointer' }}
                              onClick={() => viewMore(event)}
                            >
                              <GroupIcon style={{ fontSize: 16 }} /> {studentCount}
                              {uploadedCount > 0 ? <span className={classes.docPill}>{uploadedCount} doc</span> : null}
                            </span>
                          </Tooltip>
                        </TableCell>
                      )}
                      <TableCell style={{ fontWeight: 600, color: '#0f2d4d' }}>{event.eventName}</TableCell>
                      {visibleCols.createdBy && (
                        <TableCell style={{ color: '#46566b' }}>
                          {getCreatedByLabel(event.createdBy)}
                        </TableCell>
                      )}
                      {/* <TableCell>
                        {event.classId ? <Chip size="small" label={event.classId.className} className={classes.classChip} /> : '—'}
                      </TableCell>
                      {visibleCols.section && (
                        <TableCell>
                          {event.sectionId && event.sectionId.sectionName
                            ? <Chip size="small" label={event.sectionId.sectionName} className={classes.sectionChip} />
                            : '—'}
                        </TableCell>
                      )} */}
                      {visibleCols.eventDate && (
                        <TableCell>
                          <Box display="flex" alignItems="center" gridGap={6}>
                            <EventIcon style={{ fontSize: 15, color: '#9aa6b6' }} />
                            {event.date && event.date !== "Invalid Date" ? formatDate(event.date) : "N/A"}
                          </Box>
                        </TableCell>
                      )}
                      {visibleCols.dueDate && (
                        <TableCell>
                          <Box display="flex" alignItems="center" gridGap={6}>
                            <EventIcon style={{ fontSize: 15, color: overdue ? '#c62828' : '#9aa6b6' }} />
                            <span style={overdue ? { color: '#c62828', fontWeight: 600 } : undefined}>
                              {formatDate(event.dueDate)}
                            </span>
                          </Box>
                        </TableCell>
                      )}
                      {visibleCols.remarks && (
                        <TableCell align="center" style={{ color: '#46566b' }}>
                          {event.discription ? (
                            <Tooltip title="View remarks" arrow>
                              <IconButton
                                size="small"
                                onClick={() => openRemarksDialog(event)}
                                aria-label="view remarks"
                              >
                                <DescriptionOutlinedIcon fontSize="small" style={{ color: '#1769d6' }} />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <span style={{ color: '#9aa6b6' }}>—</span>
                          )}
                        </TableCell>
                      )}
                      <TableCell align="center">
                        <IconButton size="small" onClick={(e) => openActionMenu(e, event)}>
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          rowsPerPageOptions={[1000, 10000, 1000000]}
          count={filteredEvents.length}
          page={pg}
          onPageChange={handleChangePage}
          rowsPerPage={rpg}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      {/* Column visibility menu */}
      <Menu
        anchorEl={columnMenuAnchor}
        open={Boolean(columnMenuAnchor)}
        onClose={() => setColumnMenuAnchor(null)}
      >
        {columnConfig.map((col) => (
          <MenuItem
            key={col.id}
            onClick={() => setVisibleCols((v) => ({ ...v, [col.id]: !v[col.id] }))}
          >
            <Checkbox checked={visibleCols[col.id]} size="small" color="primary" />
            {col.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Row actions menu */}
      <Menu
        anchorEl={actionMenu.anchorEl}
        open={Boolean(actionMenu.anchorEl)}
        onClose={closeActionMenu}
      >
        {/* <MenuItem onClick={() => { viewMore(actionMenu.row); closeActionMenu(); }}>
          <VisibilityIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} /> View Submissions
        </MenuItem> */}
        <MenuItem onClick={() => { editEvent(actionMenu.row); closeActionMenu(); }}>
          <EditIcon fontSize="small" style={{ marginRight: 10, color: '#46566b' }} /> Edit
        </MenuItem>
        <MenuItem onClick={() => { openDeleteConfirm(actionMenu.row); closeActionMenu(); }} style={{ color: '#dc3545' }}>
          <DeleteIcon fontSize="small" style={{ marginRight: 10 }} /> Delete
        </MenuItem>
      </Menu>

      <Dialog
        open={deleteConfirm.open}
        onClose={closeDeleteConfirm}
        disableEscapeKeyDown={deleteLoading}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { borderRadius: 12 } }}
      >
        <DialogTitle
          style={{
            backgroundColor: '#fff3cd',
            color: '#856404',
            padding: '20px 24px',
            borderBottom: '2px solid #ffc107',
            fontWeight: 600,
            fontSize: 18,
          }}
        >
          Confirm Delete
        </DialogTitle>
        <DialogContent dividers style={{ padding: '20px 24px' }}>
          <Typography variant="body2" style={{ color: '#333', fontSize: 15, lineHeight: 1.6 }}>
            Are you sure you want to delete{' '}
            <strong>{deleteConfirm.row?.eventName || 'this assignment'}</strong>? This action cannot be undone.
          </Typography>
          {deleteLoading && (
            <Box mt={2} display="flex" alignItems="center" style={{ gap: 10, color: '#856404' }}>
              <CircularProgress size={18} style={{ color: '#dc3545' }} />
              <span>Deleting… Please wait.</span>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '16px 24px',
            backgroundColor: '#f8f9fa',
            borderTop: '1px solid #dee2e6',
          }}
        >
          <Button
            onClick={closeDeleteConfirm}
            disabled={deleteLoading}
            style={{ color: '#6c757d', fontWeight: 500, textTransform: 'none', padding: '8px 20px' }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteEvent}
            variant="contained"
            disabled={deleteLoading}
            startIcon={
              deleteLoading ? <CircularProgress size={16} style={{ color: '#fff' }} /> : <DeleteIcon fontSize="small" />
            }
            style={{
              backgroundColor: '#dc3545',
              color: '#fff',
              fontWeight: 600,
              textTransform: 'none',
              padding: '8px 20px',
            }}
          >
            {deleteLoading ? 'Deleting…' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={remarksDialog.open} onClose={closeRemarksDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" gridGap={8}>
            <DescriptionOutlinedIcon style={{ color: '#1769d6' }} />
            <span>{remarksDialog.title}</span>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Typography
            variant="body2"
            style={{ color: '#46566b', whiteSpace: 'pre-wrap', lineHeight: 1.7 }}
          >
            {remarksDialog.content || 'No remarks available.'}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeRemarksDialog} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        PaperProps={{ className: classes.dialogPaper }}
      >
        <Box className={classes.dialogTitleBar}>
          <Typography className={classes.dialogTitleText}>
            {(formik.values._id || event._id) ? 'Edit Assignment' : 'Add Assignment'}
          </Typography>
          <IconButton size="small" onClick={handleClose} disabled={addEventLoading}>
            <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
          </IconButton>
        </Box>

        <DialogContent className={classes.dialogBody}>
          <Box className={classes.formSection}>
            <Typography className={classes.sectionLabel}>Class &amp; Students</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={formik.touched.classId && Boolean(formik.errors.classId)}
                >
                  <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="classId"
                    label="Select Class"
                    value={formik.values.classId}
                    onChange={e => {
                      formik.handleChange(e);
                      formik.setFieldValue('sectionId', '');
                      getSectionListByClass(e.target.value);
                      getStudentList(e, null, undefined);
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                  {formik.touched.classId && formik.errors.classId && (
                    <FormHelperText>{formik.errors.classId}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled={!formik.values.classId || sectionList.length === 0}
                >
                  <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                  <Select
                    labelId="section-select-label"
                    name="sectionId"
                    label="Select Section (Optional)"
                    value={formik.values.sectionId || ''}
                    onChange={e => {
                      formik.handleChange(e);
                      if (formik.values.classId) {
                        getStudentList({ target: { value: formik.values.classId } }, null, e.target.value || undefined);
                      }
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {sectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  disabled={formik.values.isEventForAllStudent && !(formik.values._id || event._id)}
                  error={formik.touched.studentId && Boolean(formik.errors.studentId)}
                >
                  <InputLabel id="studentName-label">Student Name</InputLabel>
                  <Select
                    labelId="studentName-label"
                    id="studentName-select"
                    label="Student Name"
                    name="studentId"
                    multiple
                    disabled={formik.values.isEventForAllStudent && !(formik.values._id || event._id)}
                    value={Array.isArray(formik.values.studentId) ? formik.values.studentId.map(String) : []}
                    onChange={formik.handleChange}
                    renderValue={(selected) => {
                      const selectedIds = (selected || []).map(String);
                      const selectedNames = studentList
                        .filter(({ _id }) => selectedIds.includes(String(_id)))
                        .map(({ studentName }) => studentName);
                      if (selectedNames.length) return selectedNames.join(', ');
                      return selectedIds.length ? `${selectedIds.length} selected` : '';
                    }}
                  >
                    {studentList.map(({ _id, studentName }) => (
                      <MenuItem key={_id} value={String(_id)}>
                        {studentName}
                      </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.studentId && formik.errors.studentId && (
                    <FormHelperText>{formik.errors.studentId}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isEventForAllStudent"
                      id="terms"
                      color="primary"
                      value={formik.values.isEventForAllStudent}
                      checked={formik.values.isEventForAllStudent}
                      disabled={Boolean(formik.values._id || event._id)}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        formik.handleChange(e);
                        if (checked) {
                          if (formik.values._id || event._id) {
                            formik.setFieldValue(
                              'studentId',
                              studentList.map(({ _id }) => String(_id))
                            );
                          } else {
                            formik.setFieldValue('studentId', []);
                          }
                        }
                      }}
                    />
                  }
                  label="For All Class Students"
                />
              </Grid>
            </Grid>
          </Box>

          <Divider />

          <Box className={classes.formSection} style={{ marginTop: 20 }}>
            <Typography className={classes.sectionLabel}>Assignment Details</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="eventName"
                  name="eventName"
                  label="Assignment"
                  type="text"
                  value={formik.values.eventName}
                  onChange={formik.handleChange}
                  error={formik.touched.eventName && Boolean(formik.errors.eventName)}
                  helperText={formik.touched.eventName && formik.errors.eventName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel id="status-select-label">Status</InputLabel>
                  <Select
                    labelId="status-select-label"
                    id="status"
                    name="status"
                    value={formik.values.status}
                    label="Status"
                    onChange={formik.handleChange}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    <MenuItem value="Submitted">Submitted</MenuItem>
                    <MenuItem value="Not Submitted">Not Submitted</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="discription"
                  name="discription"
                  label="Remarks"
                  type="text"
                  multiline
                  rows={2}
                  value={formik.values.discription}
                  onChange={formik.handleChange}
                  error={formik.touched.discription && Boolean(formik.errors.discription)}
                  helperText={formik.touched.discription && formik.errors.discription}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="date"
                  name="date"
                  label="Event Date"
                  type="date"
                  value={formik.values.date}
                  onChange={formik.handleChange}
                  error={formik.touched.date && Boolean(formik.errors.date)}
                  helperText={formik.touched.date && formik.errors.date}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="dueDate"
                  name="dueDate"
                  label="Last date for submission"
                  type="date"
                  value={formik.values.dueDate}
                  onChange={formik.handleChange}
                  error={formik.touched.dueDate && Boolean(formik.errors.dueDate)}
                  helperText={formik.touched.dueDate && formik.errors.dueDate}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Box>

          <Divider />

          <Box className={classes.formSection} style={{ marginTop: 20, marginBottom: 0 }}>
            <Typography className={classes.sectionLabel}>Documents</Typography>
            <Box className={classes.uploadBox}>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
              />
              <Box mt={1.5}>
                <Button
                  variant="contained"
                  className={classes.uploadBtn}
                  onClick={handleUpload}
                >
                  Upload
                </Button>
              </Box>
            </Box>

            {imageslist.length > 0 && (
              <Box mt={2}>
                <Typography style={{ fontWeight: 600, marginBottom: 8, color: '#0f2d4d', fontSize: '0.85rem' }}>
                  Uploaded document(s)
                </Typography>
                <Box display="flex" flexWrap="wrap" style={{ gap: 10 }}>
                  {imageslist.map((url, index) => {
                    const isPdf = typeof url === 'string' && url.toLowerCase().includes('.pdf');
                    return (
                      <Box key={index} style={{ position: 'relative' }}>
                        {isPdf ? (
                          <Box style={{ width: 100, height: 100, border: '1px solid #e6eaf0', borderRadius: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 8, background: '#fff' }}>
                            <span style={{ fontSize: 12 }}>PDF</span>
                            <Button size="small" style={{ marginTop: 4, textTransform: 'none' }} onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}>View</Button>
                          </Box>
                        ) : (
                          <img
                            src={url}
                            alt={`Preview ${index + 1}`}
                            style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 8 }}
                          />
                        )}
                        <IconButton
                          size="small"
                          style={{ position: 'absolute', top: -8, right: -8, background: '#fff', border: '1px solid #e6eaf0' }}
                          onClick={() => removeImage(index, url)}
                        >
                          <CloseIcon style={{ fontSize: 14 }} />
                        </IconButton>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions className={classes.dialogFooter}>
          <Button onClick={handleClose} disabled={addEventLoading} className={classes.cancelBtn}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            className={classes.addBtn}
            onClick={formik.handleSubmit}
            disabled={addEventLoading}
            startIcon={addEventLoading ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {addEventLoading
              ? (event._id ? 'Updating…' : 'Adding…')
              : (event._id ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
  <DialogTitle>
    {selectEventName?.eventName}
    {selectedStudents.length > 0 && (
      <span style={{ fontSize: 14, fontWeight: 'normal', display: 'block', marginTop: 4 }}>
        Number of students: {selectedStudents.length}
        {(selectedStudents.filter(s => s.submissionFiles && s.submissionFiles.length > 0).length) > 0 && (
          <> · Parent documents uploaded: {selectedStudents.filter(s => s.submissionFiles && s.submissionFiles.length > 0).length}</>
        )}
      </span>
    )}
  </DialogTitle>
  <DialogContent>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Student Name</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Resubmitted status</TableCell>
          <TableCell>Parent uploaded document</TableCell>
          <TableCell>Remark</TableCell>
          <TableCell>Action</TableCell>
        </TableRow>
      </TableHead>

    

      <TableBody>
        {selectedStudents.map((student, index) => (
          <TableRow key={student._id || index}>
            <TableCell>{student.studentId?.firstName} {student.studentId?.lastName}</TableCell>
            <TableCell className="pl-3 fw-normal">
              {(() => {
                const status = student.status || 'Not Submitted';
                const isSubmitted = String(status).toLowerCase() === 'submitted';
                return (
                  <Chip
                    size="small"
                    label={status}
                    className={isSubmitted ? classes.submittedChip : classes.notSubmittedChip}
                  />
                );
              })()}
           </TableCell>
           <TableCell className="pl-3 fw-normal">
              {(() => {
                const resubmit = student.resubmit || 'Not Submitted';
                const normalized = String(resubmit).toLowerCase();
                const chipClass =
                  normalized === 'submitted'
                    ? classes.submittedChip
                    : normalized === 'resubmit'
                      ? classes.resubmitChip
                      : classes.notSubmittedChip;
                return (
                  <Chip
                    size="small"
                    label={resubmit}
                    className={chipClass}
                  />
                );
              })()}
           </TableCell>
           <TableCell className="pl-3 fw-normal">
            {(student.submissionFiles && student.submissionFiles.length > 0) ? (
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto auto",
                  columnGap: 10,
                  rowGap: 8,
                  alignItems: "center",
                }}
              >
                {student.submissionFiles.map((url, i) => (
                  <React.Fragment key={i}>
                    <Typography
                      variant="body2"
                      style={{ color: "#46566b", whiteSpace: "nowrap" }}
                    >
                      Document {i + 1}
                    </Typography>
                    <a
                      href={url}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1769d6", fontWeight: 600, textDecoration: "underline", whiteSpace: "nowrap" }}
                    >
                      Download
                    </a>
                  </React.Fragment>
                ))}
              </Box>
            ) : (
              <span>—</span>
            )}
           </TableCell>
           <TableCell className="pl-3 fw-normal" style={{ minWidth: 220 }}>
            {editingRemarkId === student._id ? (
              <Box display="flex" alignItems="flex-start" gridGap={8}>
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Enter remark"
                  multiline
                  minRows={1}
                  maxRows={3}
                  fullWidth
                  autoFocus
                  value={remarkDrafts[student._id] || ''}
                  onChange={(e) => {
                    const value = e?.target?.value ?? '';
                    const studentKey = student?._id;
                    if (!studentKey) return;
                    setRemarkDrafts((prev) => ({ ...(prev || {}), [studentKey]: value }));
                  }}
                />
                <Box display="flex" flexDirection="column" gridGap={6} style={{ marginTop: 2 }}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    style={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                    disabled={remarkSavingId === student._id}
                    onClick={() => saveStudentRemark(student)}
                  >
                    {remarkSavingId === student._id ? 'Saving…' : 'Save'}
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    style={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                    disabled={remarkSavingId === student._id}
                    onClick={() => cancelRemarkEdit(student)}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box display="flex" alignItems="flex-start" gridGap={6}>
                <Typography
                  variant="body2"
                  style={{
                    color: student.remark ? '#46566b' : '#9aa6b6',
                    whiteSpace: 'pre-wrap',
                    flex: 1,
                    lineHeight: 1.5,
                  }}
                >
                  {student.remark || '—'}
                </Typography>
                <Tooltip title="Edit remark" arrow>
                  <IconButton
                    size="small"
                    onClick={() => startRemarkEdit(student)}
                    aria-label="Edit remark"
                  >
                    <EditIcon fontSize="small" style={{ color: '#1769d6' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
           </TableCell>
           <TableCell className="pl-3 fw-normal">
            {(() => {
              const pastDue = isDueDatePassed(selectEventName?.dueDate);
              const resubmitStatus = student.resubmit || "Not Submitted";
              if (!pastDue && student.status === "Not Submitted") {
                return (
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "rgb(15 59 98)", color: "white" }}
                    onClick={() => submitAssigment(student, "Submitted")}
                  >
                    Submit
                  </Button>
                );
              }
              if (pastDue && (resubmitStatus === "Submitted" || resubmitStatus === "Resubmit")) {
                return (
                  <Typography variant="body2" style={{ color: "#2e7d32", fontWeight: 600 }}>
                    Requested
                  </Typography>
                );
              }
              return null;
            })()}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => { setOpenDialog(false); setEditingRemarkId(null); }} color="primary">
      Close
    </Button>
  </DialogActions>
</Dialog>

    </>
  );
}

